import React from 'react'
import { StyleSheet } from 'react-native'

import { B5, SH2 } from '@zet/design-system'
import { Stack, XStack } from '@zet/design-system/layout'

import { useAccumulatedCash } from '../../api/hooks'
import CoinLocked from '../../assets/svg/coinLocked.svg'
import { i18n } from '../../localization'
import AccumulatedPayoutCardLoader from './accumulatedPayoutCardLoader'

export const AccumulatedPayoutCard = () => {
  const { data: accumulatedCash, isLoading } = useAccumulatedCash()

  if (isLoading) {
    return <AccumulatedPayoutCardLoader />
  }

  return (
    <>
      {accumulatedCash?.accPayout !== '0' && (
        <Stack className="mx-3 mb-3 rounded border-2" style={styles.mainBox}>
          <XStack
            className="items-center rounded border px-3 py-2"
            style={styles.innerBox}
          >
            <CoinLocked />
            <Stack className="ml-3">
              <XStack className="items-center">
                <SH2 className="text-grays-100 font-[Graphie-Bold]">
                  {i18n.t('accumulatedPayout.locked', {
                    amount: accumulatedCash?.accPayout,
                  })}
                </SH2>
              </XStack>
              <B5 className="text-grays-60">
                {i18n.t('accumulatedPayout.title')}
              </B5>
            </Stack>
          </XStack>
        </Stack>
      )}
    </>
  )
}
const styles = StyleSheet.create({
  mainBox: {
    borderColor: '#FEE6BA',
  },
  innerBox: {
    borderColor: '#FFB000',
    backgroundColor: '#F3F7FE',
  },
})
